module.exports = __webpack_public_path__ + "static/media/03_07_07.dd0d428d.png";